module.exports = __webpack_public_path__ + "ma.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/ma.svg
// module id = 675
// module chunks = 0